import { createAction } from '@reduxjs/toolkit';

// Generic htmx bootstrap signal, handled by the htmxEvent epic. Unlike
// sendInitFitmentSearchRequest (Core/actions/fitmentSearch/request.ts), this
// isn't gated on the page having a YMM widget, so it also covers non-fitment
// stores and fitment-search pages without a VehicleWidget.
export const sendInitHtmxRequest = createAction('SEND_INIT_HTMX_REQUEST');
